/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import ticketValidator from '@touchplan/config/lib/ticket-validators.json';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { MaterialModule } from 'src/app/common/material/material-module';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';
import { GenericDialogComponent } from 'src/app/common/generic-dialog/generic-dialog.component';

@Component({
	standalone: true,
	imports: [MaterialModule, PresentationModule, ReactiveFormsModule],
	selector: 'crew-size-editor',
	templateUrl: './crew-size-editor.component.html',
	styleUrls: ['./crew-size-editor.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrewSizeEditorComponent extends GenericDialogComponent {
	public minSize = ticketValidator.liveCrewSize.min;
	public maxSize = ticketValidator.liveCrewSize.max;

	public crewSizeForm = new FormGroup({
		crewSize: new FormControl<number>(+this.data.content, [
			Validators.min(this.minSize),
			Validators.max(this.maxSize),
		]),
	});

	public onButtonCloseSelect() {
		this.dialogRef.close();
	}
	public onSave() {
		this.dialogRef.close({
			defaultCrewSize: this.crewSizeForm.value.crewSize,
		});
	}
}
